// Thin adapter. The implementation now lives in @intrasync/stores
// (specialized/RegistrationStore); this file exists only to preserve the local
// import path 'stores/RegistrationStore', the local default export, and the
// local RootStore constructor type.
//
// Why a cast and not `class RegistrationStore extends LibRegistrationStore`:
// the library store calls makeAutoObservable(this) in its constructor, and MobX
// throws ("can only be used for classes that don't have a superclass") when the
// instance has one. A subclass shim would crash at startup.
//
// Why the bare '@intrasync/stores' specifier: tsconfig.json sets
// "moduleResolution": "Node", which ignores the package `exports` map, so
// '@intrasync/stores/specialized/RegistrationStore' does not resolve for
// TypeScript. The root barrel re-exports RegistrationStore, so this does.
import { RegistrationStore as LibRegistrationStore } from '@intrasync/stores';
import type RootStore from './RootStore';

/**
 * The library types its stores against ITS OWN RootStore, which declares
 * `private` members and is therefore nominal to TypeScript. This app mounts its
 * local RootStore, which is structurally compatible at runtime (the store reads
 * only rootStore.userStore, .routerStore and .notificationStore). Re-type the
 * constructor here so no call site has to cast. The second parameter is
 * optional, so the existing `new RegistrationStore(this)` call in RootStore.ts
 * keeps compiling unchanged.
 */
type RegistrationStoreConstructor = new (
  rootStore: RootStore,
  options?: { debugMode?: boolean }
) => LibRegistrationStore;

const RegistrationStore =
  LibRegistrationStore as unknown as RegistrationStoreConstructor;
type RegistrationStore = LibRegistrationStore;

export default RegistrationStore;
